<script setup>
import { useRoute } from 'vue-router'
import { computed } from 'vue'
import AuthLayout from './layouts/AuthLayout.vue'
import DefaultLayout from './layouts/DefaultLayout.vue'

const route = useRoute()
const authRoutes = ['/', '/login', '/forgotpassword', '/changepassword', '/register', '/activate', '/adminweb']

const layoutComponent = computed(() =>
  authRoutes.includes(route.path) ? AuthLayout : DefaultLayout
)
</script>

<template>
  <component :is="layoutComponent">
    <router-view />
  </component>
</template>
